__turbopack_context__.v({
  "day": "_6WNySq_day",
  "dayInRange": "_6WNySq_dayInRange",
  "daySelected": "_6WNySq_daySelected",
  "dayToday": "_6WNySq_dayToday",
  "empty": "_6WNySq_empty",
  "grid": "_6WNySq_grid",
  "header": "_6WNySq_header",
  "monthLabel": "_6WNySq_monthLabel",
  "navButton": "_6WNySq_navButton",
  "root": "_6WNySq_root",
  "weekday": "_6WNySq_weekday",
  "weekdays": "_6WNySq_weekdays",
});
